import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../../../providers/theme";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../style.css";
import { isMobile } from "react-device-detect";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../../..";
import {
  HOME_BANNER_MAX_IMAGES,
  HOME_BANNER_MIN_IMAGES,
  HOME_PAGE_BANNERS_DOC_ID,
  HOME_PAGE_SETTINGS_COLLECTION,
} from "../../../admin_portal/about/home_banner_settings_tab";

const HOME_BANNER_DEFAULT_ITEMS = [
  {
    name: "Carousel 1",
    img: "/images/banners/banner_1.jpg",
  },
  {
    name: "Carousel 1",
    img: "/images/banners/banner_2.JPG",
  },
  {
    name: "Carousel 1",
    img: "/images/banners/banner_3.JPG",
  },
  {
    name: "Carousel 1",
    img: "/images/banners/banner_4.jpg",
  },
];

export default function HeroSection() {
  const [items, setItems] = useState(HOME_BANNER_DEFAULT_ITEMS);

  useEffect(() => {
    let isMounted = true;

    async function loadBannerSettings() {
      try {
        const snapshot = await getDoc(
          doc(firestore, HOME_PAGE_SETTINGS_COLLECTION, HOME_PAGE_BANNERS_DOC_ID),
        );
        const bannerImages = (snapshot.data() as { bannerImages?: string[] } | undefined)?.bannerImages || [];

        if (!isMounted) {
          return;
        }

        if (
          bannerImages.length >= HOME_BANNER_MIN_IMAGES &&
          bannerImages.length <= HOME_BANNER_MAX_IMAGES
        ) {
          setItems(
            bannerImages.map((img, index) => ({
              name: `Carousel ${index + 1}`,
              img,
            })),
          );
        } else {
          setItems(HOME_BANNER_DEFAULT_ITEMS);
        }
      } catch (error) {
        console.error("Failed to load homepage banner settings", error);
        if (isMounted) {
          setItems(HOME_BANNER_DEFAULT_ITEMS);
        }
      }
    }

    loadBannerSettings();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Box mt={2}>
      <Carousel
        autoPlay={true}
        dynamicHeight={false}
        showStatus={false}
        showThumbs={false}
        infiniteLoop={true}
        showArrows={false}
        interval={2000}
        renderItem={(children) => {
          return <Box mb={6}>{children}</Box>;
        }}
        renderIndicator={(onClick, isSelected) => {
          return (
            <Box
              display="inline-block"
              mx={0.2}
              mt={10}
              sx={{
                borderRadius: 8,
                width: isSelected ? 24 : 8,
                transition: "all 1s",
                height: 8,
                backgroundColor: isSelected
                  ? theme.palette.primary.main
                  : "white",
                border: `1px solid ${theme.palette.primary.main}`,
                mr: 2,
              }}
            />
          );
        }}
      >
        {items.map((image) => {
          return (
            <Box
              sx={{
                position: "relative",
              }}
            >
              <Box
                sx={{
                  "& ::before": {
                    content: "''",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: 50,
                    height: 50,
                    borderTopRightRadius: 50,
                    boxShadow: "-15px -15px 0 15px #fff",
                  },
                }}
              >
                <img
                  style={{
                    height: isMobile ? "25vh" : "80vh",
                    width: "100%",
                    borderRadius: 20,
                    objectFit: "cover",
                  }}
                  src={image.img}
                  alt=""
                />
              </Box>
            </Box>
          );
        })}
      </Carousel>
    </Box>
  );
}
